import { useAtom } from "jotai";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  accessTokenAtom,
  isAnonymousUserAtom,
  refreshTokenAtom,
} from "@/utils/atoms";

/*
 * This hook handles the redirect to the partner portal after the user has logged in.
 * For partner app, we simply redirect to the cockpit if authenticated.
 */
export const usePartnerLoginRedirect: () => boolean = () => {
  const [accessToken] = useAtom(accessTokenAtom);
  const [refreshToken] = useAtom(refreshTokenAtom);
  const [isRedirecting, setIsRedirecting] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const authorized = !!accessToken;

  const [isAnonymousUser] = useAtom(isAnonymousUserAtom);

  useEffect(() => {
    if (!authorized && !location.pathname.startsWith("/welcome-partner")) {
      setIsRedirecting(true);
      navigate("/welcome-partner", { replace: true });
    }
  }, [authorized, navigate, location.pathname]);

  useEffect(() => {
    if (accessToken && refreshToken && !isAnonymousUser) {
      setIsRedirecting(true);
      navigate("/partner/cockpit", { replace: true });
    }

    setIsRedirecting(false);
  }, [authorized, accessToken, isAnonymousUser, navigate, refreshToken]);

  return isRedirecting;
};
